import { render } from "./PackagesListing.vue?vue&type=template&id=72d99428&ts=true"
import script from "./PackagesListing.vue?vue&type=script&lang=ts"
export * from "./PackagesListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__